import {Notification} from 'element-ui'
import http from './http'
import storage from './storage'
import Bus from './Bus'
import formatter from './formatter'
import validator from './validator'

const error = {
  formError(options) {

    let _options = {
      type: 'error',
      title: '错误',
      message: '数据填写错误，请重新填写！',
    }

    Object.assign(_options, options)

    Notification(_options)

    return false
  }
}

export {
  http,
  storage,
  Bus,
  formatter,
  validator
}

export default {
  http,
  error,
  storage,
  Bus,
  formatter,
  validator
}



// WEBPACK FOOTER //
// ./src/utils/index.js